import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import { Dialog } from 'react-toolbox/lib/dialog';
import { SHOW_VALIDATION_ERRORS_DIALOG } from 'submission/submissionActions';
import { getValidationErrorsDialogVisible } from 'submission/submissionReducer';
import theme from 'shared-styles/ErrorDialogTheme.css';

const ValidationErrorsDialog = ({ visible, onCancel }) =>
  <Dialog
    theme={theme}
    actions={[{ label: 'OK', onClick: onCancel }]}
    active={visible}
    onEscKeyDown={onCancel}
    onOverlayClick={onCancel}
    title="Oops"
  >
    <p>
      Please correct the indicated errors so that you can proceed to the next
      step.
    </p>
  </Dialog>;

const mapState = R.pipe(
  R.path(['submission']),
  R.applySpec({
    visible: getValidationErrorsDialogVisible,
  }),
);

const mapDispatch = dispatch => ({
  onCancel: () =>
    dispatch({ type: SHOW_VALIDATION_ERRORS_DIALOG, show: false }),
});

export default connect(mapState, mapDispatch)(ValidationErrorsDialog);



// WEBPACK FOOTER //
// ./src/submission/components/ValidationErrorsDialog.js